import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, Lock } from 'lucide-react';
import { InputField } from '../components/InputField';
import { Button } from '../components/Button';
import { loginUser } from '../api/auth';
import { useAuth } from '../store/authStore';
export function LoginScreen() {
  const navigate = useNavigate();
  const {
    login
  } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validate = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.email || !/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email';
    }
    if (!formData.password) {
      newErrors.password = 'Password is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (errors[e.target.name]) {
      setErrors({
        ...errors,
        [e.target.name]: ''
      });
    }
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    if (!validate()) return;
    setIsLoading(true);
    try {
      const response = await loginUser({
        email: formData.email,
        password: formData.password
      });
      login(response.token, response.user);
      navigate('/app/dashboard');
    } catch (err: any) {
      setError(err.message || 'Invalid email or password');
    } finally {
      setIsLoading(false);
    }
  };
  return <div className="min-h-screen w-full bg-background md:bg-secondary flex flex-col items-center justify-center p-0 md:p-6 animate-fadeInUp" data-id="element-1459" data-mp="1tnbgrc8c25r5">
      <div className="w-full max-w-[480px] min-h-screen md:min-h-0 bg-background md:rounded-card md:shadow-elevated flex flex-col relative" data-id="element-1460" data-mp="1onyr6jq2ukkv">
        {error && <div className="absolute top-0 left-0 right-0 bg-danger text-white p-4 text-center text-sm font-medium animate-slideDown z-20 md:rounded-t-card" data-id="element-1461" data-mp="r9nifdmdeeet">
            {error}
          </div>}

        <div className="p-6 pt-12 flex-1" data-id="element-1462" data-mp="10b3l0z6y1c8h">
          <button onClick={() => navigate('/intro')} className="mb-8 text-text-secondary hover:text-text-primary transition-colors" aria-label="Go back" data-id="element-1463" data-mp="10a26gkqpy7m0">
            <ArrowLeft size={24} data-id="element-1464" data-mp="7mfxewyq2arr" />
          </button>

          <div className="mb-8" data-id="element-1465" data-mp="cl0tqlausaax">
            <h1 className="text-[28px] font-semibold text-text-primary mb-2" data-id="element-1466" data-mp="cjpp6j9l2yir">
              Welcome back
            </h1>
            <p className="text-[16px] text-text-secondary" data-id="element-1467" data-mp="hdu0tftsnuq6">
              Sign in to continue with Aurora Care
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4" data-id="element-1468" data-mp="3l0asbjfjaxdy">
            <label htmlFor="email" className="sr-only" data-id="element-1469" data-mp="3dhjo5cbo4n8y">
              Email
            </label>
            <InputField id="email" name="email" type="email" placeholder="your@email.com" icon={<Mail size={20} data-id="element-1471" data-mp="33i2jmy85kfek" />} value={formData.email} onChange={handleChange} error={errors.email} data-id="element-1470" data-mp="3df766z5wucvw" />

            <div data-id="element-1472" data-mp="2uifhga7ln5kg">
              <label htmlFor="password" className="sr-only" data-id="element-1473" data-mp="2uiz0ju8zk002">
                Password
              </label>
              <InputField id="password" name="password" type="password" placeholder="Enter your password" icon={<Lock size={20} data-id="element-1475" data-mp="2fu2vm628733o" />} value={formData.password} onChange={handleChange} error={errors.password} data-id="element-1474" data-mp="2prpfl6ydtkui" />
              <div className="flex justify-end mt-1" data-id="element-1476" data-mp="2bu0rlq90pxl8">
                <button type="button" onClick={() => navigate('/forgot-password')} className="text-primary text-[14px] hover:opacity-80 transition-opacity" data-id="element-1477" data-mp="26u61hox2hc18">
                  Forgot password?
                </button>
              </div>
            </div>

            <div className="pt-6 pb-8" data-id="element-1478" data-mp="zwwndzxjiyh">
              <Button type="submit" isLoading={isLoading} loadingText="Signing in..." data-id="element-1479" data-mp="5z04153du19m">
                Sign In
              </Button>

              <div className="mt-6 text-center" data-id="element-1480" data-mp="3s683xrvj9fy9">
                <button type="button" onClick={() => navigate('/register')} className="text-primary font-medium text-[14px] hover:opacity-80 transition-opacity" data-id="element-1481" data-mp="3s819t4ybnw57">
                  Don't have an account? Create one
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>;
}